import { useEffect, useMemo, useRef } from 'react'
import {
  STATIC_QUICK_ACTIONS,
  buildQuickActionsMiniSearchIndex,
  searchQuickActionsMiniSearch,
} from '../local/quickActionsRegistry'

/**
 * Runs the quick-actions list through a MiniSearch (BM25) index and routes
 * results to SupplementarySearchContext under
 * providerId='quick-actions-minisearch'.
 *
 * This is the only engine behind the quick-action rows — it presents to users
 * and feeds the non-content section of the search-quality report.
 */
function QuickActionsMiniSearchProvider({ query, options, onResults }) {
  const ms = useMemo(() => buildQuickActionsMiniSearchIndex(STATIC_QUICK_ACTIONS), [])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 6
    const hits = searchQuickActionsMiniSearch(ms, query, limit)
    onResultsRef.current({ hits })
  }, [query, ms, options])

  return null
}

export default QuickActionsMiniSearchProvider
